export { createPageMeta } from './meta';



// WEBPACK FOOTER //
// ../../../../src/metas/page/index.ts